var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "needsValidation page-container" }, [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("menu.online_payout")) + " "),
    ]),
    _c("div", { staticClass: "filter-container" }, [
      _c("div", { staticClass: "custom-breadcrumbs" }, [
        _c("i", {
          staticClass: "el-icon-arrow-left icon-back",
          on: { click: _vm.onClickBackBtn },
        }),
        _c("span", { on: { click: _vm.onClickBackBtn } }, [
          _vm._v(_vm._s(_vm.$t("customerService.payment_details"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "btn-container" },
        [
          _vm.status === _vm.statusObj["Needs_Validation"]
            ? _c(
                "el-button",
                {
                  staticClass: "mb-10 download-btn",
                  attrs: {
                    type: "danger",
                    size: "small",
                    icon: "el-icon-delete",
                  },
                  on: { click: _vm.onClickDeleteBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.delete")))]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "tableContainer" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.listLoading,
                expression: "listLoading",
              },
            ],
            staticClass: "tableContainer",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              fit: "",
              "highlight-current-row": "",
            },
            on: { "selection-change": _vm.handleSelectionChange },
          },
          [
            _vm.status === _vm.statusObj["Needs_Validation"]
              ? _c("el-table-column", {
                  attrs: { type: "selection", width: "55" },
                })
              : _vm._e(),
            _vm.status === _vm.statusObj["Approved"]
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.transaction_id"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " + _vm._s(scope.row.transaction_id) + " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4258758155
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("customerService.reference"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(scope.row.reference_batch_no)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("merchantAccount.recipient_channel"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_c("span", [_vm._v(_vm._s(scope.row.full_name))])]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: _vm.$t("components.amount"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("toThousandFilter")(scope.row.amount))
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm.status !== _vm.statusObj["Approved"]
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("customerService.validation"),
                    align: "center",
                    "min-width": "100",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.unvalidated_fields &&
                            scope.row.unvalidated_fields.length > 0
                              ? _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.unvalidated_fields.join(
                                                ","
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-tag",
                                      {
                                        staticClass: "tag-custom",
                                        attrs: { type: "danger" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.unvalidated_fields.join(
                                              ","
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "el-tag",
                                  {
                                    staticClass: "tag-custom",
                                    attrs: { type: "success" },
                                  },
                                  [_vm._v("Passed")]
                                ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3702253460
                  ),
                })
              : _vm._e(),
            _vm.status === _vm.statusObj["Approved"]
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("merchantAccount.transaction_status"),
                    "min-width": "150",
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                staticClass: "tag-custom",
                                attrs: {
                                  type: _vm.getPOTransactionStatusType(
                                    scope.row.transaction_status
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getPOTransactionStatusMap(
                                        scope.row.transaction_status
                                      )
                                    )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2984644139
                  ),
                })
              : _vm._e(),
            _vm.status === _vm.statusObj["Approved"]
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("merchantAccount.create_time"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.transaction_create_time)),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2049561395
                  ),
                })
              : _vm._e(),
            _vm.status === _vm.statusObj["Approved"]
              ? _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("merchantAccount.complete_time"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.transaction_return_time)),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3300105469
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: { label: _vm.$t("components.operation"), align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      [
                        _vm.statusObj["Needs_Validation"],
                        _vm.statusObj["Checker"],
                      ].includes(_vm.status)
                        ? _c(
                            "el-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("components.edit"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c("svg-icon", {
                                attrs: {
                                  "class-name": "icon-function ",
                                  "icon-class": "operation-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickEditBtn(scope.row)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.status === _vm.statusObj["Needs_Approval"]
                        ? _c(
                            "el-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("components.detail"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c("svg-icon", {
                                attrs: {
                                  "class-name": "icon-function",
                                  "icon-class": "operation-detail",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickNeedsApprovalDetail(
                                      scope.row
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.status === _vm.statusObj["Approved"]
                        ? _c(
                            "el-tooltip",
                            {
                              class: {
                                disabled: !scope.row.transaction_status,
                              },
                              attrs: { placement: "top" },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("components.detail"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c("svg-icon", {
                                attrs: {
                                  "class-name": "icon-function",
                                  "icon-class": "operation-detail",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickDetailTxt(scope.row)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      scope.row.transaction_status === 4
                        ? _c(
                            "el-tooltip",
                            { attrs: { placement: "top" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("components.retry"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c("svg-icon", {
                                attrs: {
                                  size: "mini",
                                  type: "warning",
                                  "class-name": "icon-function",
                                  "icon-class": "retry",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickRetryBtn(scope.row)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("SingleDisbursementEditModal", {
          ref: "singleDisbursementEditModal",
          on: {
            getDisbursementRefernceDetail: _vm.getDisbursementRefernceDetail,
          },
        }),
        _c("NeedsApprovalDetail", { ref: "needsApprovalDetail" }),
        _c("po-details-modal", {
          ref: "poMentDetailsModal",
          attrs: { "detail-id": _vm.detailId },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }